import styled from 'styled-components';

import { media } from '../../../../../helpers/breakpoints';

const ProviderLogo = styled.img`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  height: 76px;
`;

const Heading = styled.h1`
  ${({ theme }) => theme.fontSize.L18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    ${({ theme }) => theme.fontSize.L24};
  }
`;

const Copy = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export { ProviderLogo, Heading, Copy };
